export default "__VITE_ASSET__B9EYl85X__"